<template>
  <a
    :href="url"
    :target="target"
    :class="[
      'wb-button',
      `wb-button--${type}`,
      `wb-button--medium`,
      { 'wb-button--theme-dark': isDarkModeOn },
    ]"
  >
    {{ label }}
  </a>
</template>

<script lang="ts">
import Vue from 'vue';
import { FeatureButtonComponent } from './FeatureBox';

export default (Vue as FeatureButtonComponent).extend({
  name: 'owc-feature-box-button',
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
    ctaData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isDarkModeOn() {
      return Boolean(this.darkMode);
    },
    type() {
      return this.ctaData.type;
    },
    url() {
      return this.ctaData.url;
    },
    label() {
      return this.ctaData.label;
    },
    target() {
      return this.ctaData.target;
    },
  },
});
</script>
